import { render, staticRenderFns } from "./TenantApiForm.vue?vue&type=template&id=57a9df04"
import script from "./TenantApiForm.vue?vue&type=script&lang=js"
export * from "./TenantApiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports